import { z } from 'zod';
import {
    type NodeSocketCfg,
    baseNodeCfgSchema,
} from './base-node';

export const workInstructionStatusNodeCfgSchema = baseNodeCfgSchema.extend({
    kind: z.literal('workInstructionStatus'),
    controlValues: z.object({
        workInstructionVersionId: z.string().uuid(),
    }),
});
export interface WorkInstructionStatusNodeCfgSchema extends z.infer<typeof workInstructionStatusNodeCfgSchema> {}

export const workInstructionStatusNodeSocketCfg = {
    controlSockets: {
        inputs: () => ({
            trigger: 'event',
        }),
        outputs: () => ({
            next: 'event',
        }),
    },
    dataSockets: {
        inputs: () => ({
            materialId: 'string',
        }),
        outputs: () => ({
            status: 'string',
            totalSteps: 'number',
            completedSteps: 'number',
        }),
    },
} satisfies NodeSocketCfg<WorkInstructionStatusNodeCfgSchema>;
